import { Card } from '@common/components';
import { FC, useEffect } from 'react';
import { shallowEqual } from 'react-redux';
import { NavLink, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/store';
import { fetchIssue } from 'src/store/issue';
import { useTranslation } from 'react-i18next';
import { ChevronLeft } from '@geist-ui/icons';
import { PATHS } from 'src/constants';

import styles from './styles.module.scss';
import { Issue } from 'src/components/Issue';
import { StickyBar } from 'src/components';
import { Text } from '@mantine/core';

const IssuePage: FC = () => {
  const { id, issueId } = useParams<{ id: string; issueId: string }>();

  const dispatch = useAppDispatch();
  const [c] = useTranslation('nav');

  const issue = useAppSelector((state) => state.issue.data, shallowEqual);

  useEffect(() => {
    dispatch(fetchIssue({ siteId: id, issueId: issueId }));
  }, [id]);

  return (
    <div>
      <StickyBar className={styles.bar}>
        <NavLink to={`${PATHS.DASHBOARD}/${id}/${PATHS.REPORTED}`} className={styles.back}>
          <ChevronLeft color="#5b5eff" />
          <Text>{c('navBackToAllReports')}</Text>
        </NavLink>
      </StickyBar>
      <Card className={styles.card}>
        <div className={styles.date}></div>
        <Issue issue={issue} />
      </Card>
    </div>
  );
};

export default IssuePage;
